/**
 * Deserializes a message payload that was previously encoded using a 1-byte version
 * and a 2-byte big-endian message length prefix, followed by UTF-8 encoded message bytes.
 *
 * Format:
 * - 1 byte: version (must be 1)
 * - 2 bytes: message length (big-endian)
 * - N bytes: UTF-8 encoded message
 *
 * @param payload - The Uint8Array to deserialize
 * @returns An object with the extracted version and message string
 */
export function deserializeMessagePayload(payload: Uint8Array): {
  version: number;
  message: string;
} {
  if (payload.length < 3) {
    throw new Error('Payload too short to contain version and length');
  }

  const version = payload[0];
  if (version !== 1) {
    throw new Error(`Unsupported version: ${version}`);
  }

  const length = (payload[1] << 8) | payload[2];
  const expectedTotalLength = 3 + length;

  if (payload.length < expectedTotalLength) {
    throw new Error('Payload truncated: not enough data for declared message length');
  }

  const messageBytes = payload.slice(3, expectedTotalLength);
  const decoder = new TextDecoder();
  const message = decoder.decode(messageBytes);

  return { version, message };
}